import React, { useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { AdminLayout } from '../../components/admin/AdminLayout';
import { TabNavigation } from '../../components/admin/TabNavigation';
import { AdminChatbotKnowledge } from './AdminChatbotKnowledge';
import { AdminChatbotLogs } from './AdminChatbotLogs';
import { AdminChatbotSupport } from './AdminChatbotSupport';
import { AdminChatbotConfig } from './AdminChatbotConfig';
import {
  Database,
  MessageSquare,
  Ticket,
  Settings
} from 'lucide-react';

type TabId = 'knowledge' | 'logs' | 'support' | 'config';

export function AdminChatbot() {
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();
  const activeTab = (searchParams.get('tab') || 'knowledge') as TabId;

  useEffect(() => {
    if (!searchParams.get('tab')) {
      setSearchParams({ tab: 'knowledge' }, { replace: true });
    }
  }, [searchParams, setSearchParams]);

  const handleTabChange = (tabId: string) => {
    setSearchParams({ tab: tabId });
  };

  const tabs = [
    {
      id: 'knowledge',
      label: 'Kennisbank',
      icon: Database,
    },
    {
      id: 'logs',
      label: 'Logs',
      icon: MessageSquare,
    },
    {
      id: 'support',
      label: 'Support Tickets',
      icon: Ticket,
    },
    {
      id: 'config',
      label: 'Configuratie',
      icon: Settings,
    },
  ];

  const renderContent = () => {
    switch (activeTab) {
      case 'knowledge':
        return <AdminChatbotKnowledge noLayout={true} />;
      case 'logs':
        return <AdminChatbotLogs noLayout={true} />;
      case 'support':
        return <AdminChatbotSupport noLayout={true} />;
      case 'config':
        return <AdminChatbotConfig noLayout={true} />;
      default:
        return <AdminChatbotKnowledge noLayout={true} />;
    }
  };

  return (
    <AdminLayout>
      <div className="space-y-6">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">dibbi Chatbot</h1>
          <p className="text-gray-600 mt-1">Beheer de chatbot kennisbank, logs en instellingen</p>
        </div>

        <TabNavigation
          tabs={tabs}
          activeTab={activeTab}
          onTabChange={handleTabChange}
        />

        <div className="mt-6">
          {renderContent()}
        </div>
      </div>
    </AdminLayout>
  );
}
